import { Button } from '@mui/material';
import { injectIntl } from 'react-intl';
import React from 'react';




export const ChatGPTPersonalAnalysisTextButton = ({ intl, onClick, style, ...rest }) => {
    return <Button
        color="primary"
        variant="outlined"
        onClick={onClick}
        style={{
            padding: '0px 4px',
            fontSize: 12,
            marginLeft: 4,
            marginRight: 4,
            minWidth: 'unset',
            ...style
        }}
        {...rest}
    >
        {intl.formatMessage({ id: 'chat-gpt-options-lazy-packs-text-button-label' })}
    </Button>
}

export default injectIntl(ChatGPTPersonalAnalysisTextButton);